<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <ValidationProvider 
                :name="field"
                :rules="rules"
                v-slot="{ errors }"
                slim
            >
                <v-text-field
                    :value="formattedDate"
                    :label="label"
                    append-icon="event"
                    :class="withMargin ? 'ml-4 mr-4' : ''" 
                    :alvqa="alvqa + '-textfield'"
                    :clearable="clearable"
                    :disabled="disabled"
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="resetVal()"
                    :error-messages="errors"
                    :readonly="true"
                ></v-text-field> 
            </ValidationProvider>
        </template>
        <v-date-picker
            v-model="date"
            :locale="this.$i18n.locale"
            no-title
            :alvqa="alvqa"
            color="buttonStandard"
            :type="type"
            :min="min"
            :disabled="disabled"
        >
            <v-spacer></v-spacer>
            <BaseButton 
                class="text-center"
                label="lang_GENERAL_BUTTON_CANCEL"
                @click="menu = false"
                :alvqa="alvqa + '-button-cancel'"
            />
            <BaseButton 
                class="text-center"
                label="lang_GENERAL_BUTTON_OK"
                @click="$refs.menu.save(date)"
                :alvqa="alvqa + '-button-ok'"
            />
        </v-date-picker>
    </v-menu>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "BaseEditPageDatePicker",
    props: {
        context: String,
        field: String,
        label: String,
        min: String,
        type: String,
        alvqa: {
            type: String,
            default: ''
        },
        withMargin: {
            type: Boolean,
            default: true
        },
        clearable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        rules: {
            type: [Object, String],
            default: ""
        },
    },
    components: {
        BaseButton
    },
    data() {
        return {
            menu: false
        }
    },
    computed:  {
        date: {
            get() { return this.$store.getters['get'+this.context + 'Details' + this.field] },
            set(newDate) { this.$store.commit('set'+ this.context + 'Details' + this.field, newDate) }
        },
        formattedDate() { 
            if(this.type === 'month') {
                 return this.date ? this.$d(new Date(this.date), 'alvMonthYearFormat') : '' 
            } else {
                return this.date ? this.$d(new Date(this.date), 'alvDateFormat') : ''                
            }
        }, 
    },
    methods: {
        async resetVal() {
            await this.$nextTick()
            this.date = null
        }
    }
}
</script>

<style>
/* workaround because of an issue: https://github.com/vuetifyjs/vuetify/issues/7610 */
.v-text-field__slot > .v-label {
    pointer-events: none !important;
}

</style>